import { select, Store } from '@ngrx/store';
import * as fromRoot from '../reducers';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

export function isCookieConsentGiven$(store: Store<fromRoot.State>): Observable<boolean> {
  return store.pipe(
    select(fromRoot.selectCoreContext),
    map((ctx) => ctx.cookieTrackingConsent != null),
    distinctUntilChanged(),
  );
}

export function getCookieConsentStatus$(store: Store<fromRoot.State>): Observable<boolean | null> {
  return store.pipe(
    select(fromRoot.selectCoreContext),
    map((ctx) => ctx.cookieTrackingConsent),
    distinctUntilChanged(),
  );
}
